import { useMemo } from 'react';
import { t } from 'i18n-js';

// @ts-ignore lib
import { fetchLegalDataAppIfNeeded } from '@lootboy/lib/actions/LegalDataAppActions';
// @ts-ignore lib
import { createVersionedLegalDataAppSelector } from '@lootboy/lib/selectors';

import config from '~/config';
import { useURLSearchParams } from '~/hooks/useURLSearchParams';
import {
  LegalPopupTemplate,
  TLegalPopupTemplate,
} from '~/popups/LegalPopups/LegalPopupTemplate';

export const LegalPopup = (): JSX.Element => (
  <LegalPopupTemplate type="legal" />
);

export const WithdrawalPopup = (): JSX.Element => (
  <LegalPopupTemplate type="withdrawal">
    {`[${t('WithdrawalView_label_download')}](${
      config.STATIC_RESOURCES_BASE_URL
    }${t('WithdrawalView_download_url')})`}
  </LegalPopupTemplate>
);

export const PrivacyPopup = (
  props: Omit<TLegalPopupTemplate, 'type'>,
): JSX.Element => (
  <LegalPopupTemplate
    {...props}
    type="privacy"
  >
    {t('privacy_radar_remark')}
  </LegalPopupTemplate>
);

export const PrivacyAppPopup = (): JSX.Element => {
  const version = useURLSearchParams('v');
  const { selector, fetchAction } = useMemo(() => {
    return {
      fetchAction: () =>
        fetchLegalDataAppIfNeeded({ versionCode: version ?? undefined }),
      selector: createVersionedLegalDataAppSelector(version ?? undefined),
    };
  }, [version]);

  return (
    <PrivacyPopup
      selector={selector}
      fetchAction={fetchAction}
    />
  );
};

export const TermsPopup = (): JSX.Element => (
  <LegalPopupTemplate type="terms">
    {t('terms_radar_remark')}
  </LegalPopupTemplate>
);
